// Auto-generado por @xone-web/staticweb a partir de LoginColl.xne.
// NO EDITAR: se regenera en cada build.
// Eventos lifecycle + custom + sintéticos (onclick/onchange por prop).

import type { XoneAPI } from "../xone-api";
import type { LoginCollFields } from "./LoginColl.types";
async function __xevt_afterEdit(api: XoneAPI<LoginCollFields>): Promise<unknown> {
    const { self, This, ThisDataColl, ui, appData, $http, crypto, clipboard, Bundle, console } = api;
    void self; void This; void ThisDataColl; void ui; void appData; void $http; void crypto; void clipboard; void Bundle; void console;
    
    var f=new Date();
                    self.setFieldPropertyValue("BTVERSION", "title", "Versión: " + appData.getGlobalMacro("##VERSION##") );
}
export { __xevt_afterEdit as afterEdit };
async function __xevt_login(api: XoneAPI<LoginCollFields>, autoLogin?: unknown): Promise<unknown> {
    const { self, This, ThisDataColl, ui, appData, $http, crypto, clipboard, Bundle, console } = api;
    void self; void This; void ThisDataColl; void ui; void appData; void $http; void crypto; void clipboard; void Bundle; void console;
    
    // para entrar directamente sin usuario temporalmente. Quitar cuando saque versiones
                    // self.USER = "admin";
                    // self.PWD = "admin";


    		  	    var params = {
                        userName: self.USER,
                        password: self.PWD,
                        // entryPoint: "LeadList",
                
                        // Opcional
                        onLoginSuccessful: function() {
                            login(self,self.USER,self.PWD);
                            ui.setSessionExpired(28800000,logoutExpirado);
                            iniciarRingover();
                        },
                
                        // Opcional
                        onLoginFailed: function() {
                            ui.showToast("Error al iniciar sesión");
                        }
                    };
                    appData.login(params);
}
export { __xevt_login as login };
async function __xevt_onback(api: XoneAPI<LoginCollFields>): Promise<unknown> {
    const { self, This, ThisDataColl, ui, appData, $http, crypto, clipboard, Bundle, console } = api;
    void self; void This; void ThisDataColl; void ui; void appData; void $http; void crypto; void clipboard; void Bundle; void console;
    
    appData.failWithMessage(-11888,"##EXITAPP##");
}
export { __xevt_onback as onback };